<script>
    import {clickOutside} from "../lib/clickOutside";
    import app from "../stores/app";
    import user from "../stores/user";
    import {router} from '../lib/Router/Router.svelte';
    import Alert from "../stores/alerts";


    let path = "";
    let activePath = '';
    let userToken = -1;

    let menu = [
        {
            id: 'dashboard',
            name: 'Dashboard',
            link: `/`,
            icon: 'dashboard',
            visible: true,
            user: ['user', 'guest'],
        },
        {
            id: 'checkin',
            name: 'Check in',
            link: `/checkin`,
            icon: 'checkin',
            visible: true,
            user: ['user', 'guest'],
        },
        {
            id: 'points',
            name: 'My Points',
            link: `/points`,
            icon: 'points',
            visible: true,
            user: ['user'],
        },
        {
            id: 'transfer-points',
            name: 'Transfer Points',
            link: `/transfer-points`,
            icon: 'gift',
            visible: true,
            user: ['user'],
        },
        // {
        //     id: 'hotels',
        //     name: 'Enorme Hotels',
        //     link: `/hotels`,
        //     icon: 'hotels',
        //     visible: true,
        //     user: ['user', 'guest'],
        // },
        {
            id: 'account',
            name: 'Account',
            link: `/account`,
            icon: 'account',
            visible: true,
            user: ['user'],
        },
    ]

    const pathFromLink = (link) => {
        return link.replace(window.location.origin, "");
    }

    const toggleMenu = (menu_id) => {
        menu.map(item => {
            if (item.menu) {
                if (item.id === menu_id) {
                    item.menu_expanded = !item.menu_expanded;
                } else {
                    item.menu_expanded = false;
                }
            }
        });
        menu = menu;
    }

    const onMenuItemClick = (event) => {
        event.preventDefault();

        let a = null;
        if (event.target.href) {
            a = event.target;
        } else {
            a = event.target.closest('a');
        }
        let link = pathFromLink(a.href);
        $app.menuExpanded = 0;
        activePath = link;
        router.go(link)();
    }

    const collapseMenu = () => {
        if ($app.menuExpanded > 0) {
            $app.menuExpanded--;
        }
    }

    const initializeMenu = () => {
        let userType = $user.token ? 'user' : 'guest';
        menu.map(item => {
            item.visible = item.user.indexOf(userType) > -1;
            // if (item.menu) {
            //     item.menu.map(subItem => {
            //         subItem.visible = subItem.user == null || (subItem.user && subItem.user.indexOf($user.is_admin) > -1);
            //     });
            // }
        });
        menu = menu;
    }

    activePath = pathFromLink(window.location.href);

    $: {
        if (userToken != $user.token) {
            userToken = $user.token;
            initializeMenu();
        }

        if (path !== activePath) {
            // expand current menu
            let arr = activePath.split("/");
            menu.map(item => {
                if (item.menu) {
                    item.menu.map(subItem => {
                        if (arr.indexOf(subItem.id) > -1) {
                            item.menu_expanded = true;
                        }
                    });
                }
            });
            path = activePath;
        }
    }
</script>

<aside class:expanded={ $app.menuExpanded > 0 }>
    <div class="app-header">
        header
    </div>
    <div class="app-menu" use:clickOutside on:click_outside="{ collapseMenu }">
        <div class="app-menu-content">
            {#each menu as item}
                {#if item.visible}
                    {#if item.menu}
                        <div class="app-menu-dropdown">
                            <div class="app-menu-item" on:click="{ () => toggleMenu(item.id) }">
                                <div class="icon">
                                    <img src="/assets/icons/navigation/{ item.icon }.svg" alt="menu icon">
                                </div>
                                <div class="caption">{ item.name }</div>
                            </div>
                            {#if item.menu_expanded}
                                <div class="app-menu-item-dropdown">
                                    {#each item.menu as subItem}
                                        {#if subItem.visible}
                                            <a href="{ subItem.link }" class="app-menu-item"
                                               class:link-active={ path === subItem.link }
                                               on:click="{ onMenuItemClick }">
                                                <span class="caption">{ subItem.name }</span>
                                            </a>
                                        {/if}
                                    {/each}
                                </div>
                            {/if}
                        </div>
                    {:else}
                        <a href="{ item.link }" class="app-menu-item" class:link-active={ path === item.link }
                           on:click="{ onMenuItemClick }">
                            <span class="icon">
                                <img src="/assets/icons/navigation/{ item.icon }.svg" alt="menu icon">
                            </span>
                            <span class="caption">{ item.name }</span>
                        </a>
                    {/if}
                {/if}
            {/each}

            {#if !$user.token}
                <div class="menu-button mt-5 mb-2" on:click={ user.showLogin }>Sign In</div>
                <div class="menu-button" on:click={ user.showSignUp }>Sign Up</div>
            {/if}
        </div>
    </div>
</aside>

<style>
    aside {
        position: fixed;
        height: 100vh;
        transition: .3s all ease;
        z-index: 5000;
    }

    .app-header {
        height: var(--header-height);
    }

    .app-menu {
        position: relative;
        width: 100%;
        height: 100%;
        /*background: #0f172a;*/
        background: #000;
        /*border-right: 1px solid #c6d2d9;*/
        transition: .3s all ease;
        overflow-y: auto;
        padding: 2rem 0.8rem;
    }

    .app-menu .app-menu-content {
        width: 100%;
    }

    .app-menu .app-menu-content .menu-button {
        color: #c3d0c9;
        /*border-radius: 20px;*/
        border-radius: 2px;
        border: 1px solid #c3d0c9;
        padding: 5px;
        text-align: center;
        cursor: pointer;
    }

    .app-menu .app-menu-content .menu-button:hover {
        color: #fff;
    }

    .app-menu-dropdown {
        position: relative;
    }

    .app-menu-dropdown .app-menu-item-dropdown .app-menu-item {
        padding-left: 50px;
    }

    @media (max-width: 576px) {
        aside {
            width: 100%;
            left: -100%;
        }

        aside.expanded {
            left: 0;
        }
    }

    @media (min-width: 577px) and (max-width: 1023px) {
        aside {
            width: var(--aside-width);
            left: -100%;
        }

        aside.expanded {
            left: 0;
        }
    }

    /*@media (min-width: 1000px) and (max-width: 1024px) {*/
    /*    aside {*/
    /*        width: 54px;*/
    /*    }*/

    /*    aside:hover, aside.expanded {*/
    /*        width: var(--aside-width);*/
    /*    }*/

    /*    .app-menu {*/
    /*        width: 100%;*/
    /*        overflow-x: hidden;*/
    /*    }*/

    /*    .app-menu .app-menu-content {*/
    /*        width: var(--aside-width);*/
    /*    }*/

    /*    .app-menu-dropdown .app-menu-item-dropdown .app-menu-item {*/
    /*        display: none;*/
    /*    }*/

    /*    aside:hover .app-menu-dropdown .app-menu-item-dropdown .app-menu-item,*/
    /*    aside.expanded .app-menu-dropdown .app-menu-item-dropdown .app-menu-item {*/
    /*        display: block;*/
    /*    }*/

    /*    aside .app-menu-item {*/
    /*        !*padding-right: 0;*!*/
    /*    }*/

    /*    aside .app-menu-item .caption {*/
    /*        !*width: 0;*!*/
    /*        !*transition: .3s all ease;*!*/
    /*        !*overflow: hidden;*!*/
    /*    }*/

    /*    aside:hover .app-menu-item .caption,*/
    /*    aside.expanded .app-menu-item .caption {*/
    /*        !*width: max-content;*!*/
    /*    }*/
    /*}*/

    @media (min-width: 1000px) {
        aside {
            width: var(--aside-width);
        }
    }

    .app-menu-item {
        position: relative;
        display: flex;
        align-items: center;
        color: #c3d0c9;
        white-space: nowrap;
        padding: 8px 15px;
        cursor: pointer;
        overflow: hidden;
        border-radius: 2px;
        margin-bottom: 5px;
    }

    .app-menu-item .icon {
        display: block;
        width: 18px;
        line-height: 1;
        margin-right: 15px;
    }

    .app-menu-item .icon img {
        width: 100%;
    }

    .app-menu-item .caption {
        display: block;
    }

    .app-menu-item:hover {
        color: #fff;
        /*background: #2c3344;*/
        background: #2c2c2c;
    }

    .app-menu-item.link-active {
        color: #fff;
        /*background: #2c3344;*/
        background: #2c2c2c;
    }
</style>